"use strict";

const EventEmitter = require("events").EventEmitter;

class ScrollbarSizeDetectionUtility extends EventEmitter {
    constructor() {
        super();

        this._inner = document.createElement("p");
        this._inner.style.width = "100%";
        this._inner.style.height = "200px";

        this._outer = document.createElement("div");
        this._outer.style.position = "absolute";
        this._outer.style.top = "0px";
        this._outer.style.left = "0px";
        this._outer.style.visibility = "hidden";
        this._outer.style.width = "200px";
        this._outer.style.height = "150px";
        this._outer.style.overflow = "hidden";
        this._outer.appendChild(this._inner);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._inner = undefined;
        this._outer = undefined;
        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * Adds some temporary markup to do scrollbar calculations. Returns the scrollbar
     * width in pixels.
     * @returns {Number}
     */
    getScrollbarWidth() {
        document.body.appendChild(this._outer);
        let w1 = this._inner.offsetWidth;
        this._outer.style.overflow = "scroll";
        let w2 = this._inner.offsetWidth;
        if (w1 === w2) {
            w2 = this._outer.clientWidth;
        }
        this._outer.style.overflow = "hidden";
        document.body.removeChild(this._outer);
        return w1 - w2;
    }

    /**
     * Adds some temporary markup to do scrollbar calculations. Returns the scrollbar
     * height in pixels.
     * @returns {Number}
     */
    getScrollbarHeight() {
        document.body.appendChild(this._outer);
        let h1 = this._inner.offsetHeight;
        this._outer.style.overflow = "scroll";
        let h2 = this._inner.offsetHeight;
        if (h1 === h2) {
            h2 = this._outer.clientWidth;
        }
        this._outer.style.overflow = "hidden";
        document.body.removeChild(this._outer);
        return h1 - h2;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ScrollbarSizeDetectionUtility;
